import { useEffect, useState } from 'react'
import { Dropdown } from 'primereact/dropdown'
import './Payment.css'
import { Button } from 'primereact/button'
import { Divider } from 'primereact/divider'
import Logo from '../../components/Logo/Logo'
import { baseUrl, getData, payment } from '../../service/api'
import { ButtonsInstallment } from './ButtonsInstallment'
import { Footer } from './Footer'
import { Skeletons } from './Skeletons'
import { useNavigate } from 'react-router-dom'
import { InputText } from 'primereact/inputtext'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm'
import Timer from '../../components/Timer/Timer'

export const Payment = ({ data, paymentPageData }) => {
    const [selectedMonthTinkoff, setSelectedMonthTinkoff] = useState(3)
    const [paymentTypes, setPaymentTypes] = useState([])
    const [currencyType, setCurrencyType] = useState([])
    const [payments, setPayments] = useState(null)
    const [dataSite, setDataSite] = useState(null)
    const [isExpired, setIsExpired] = useState(false    )
    const [expireTime, setExpireTime] = useState(null)
    const currency = [
        { name: 'Российский рубль, RUB', symbol: '₽', code: 'rub' },
        { name: 'Евро, EUR', symbol: '€', code: 'eur' },
        { name: 'Доллар, USD', symbol: '$', code: 'usd' },
        { name: 'Гривна, UAH', symbol: '₴', code: 'uah' },
    ]

    const [selectedCurrency, setSelectedCurrency] = useState(null)
    const [filters, setFilters] = useState(null)
    const navigate = useNavigate()
    const invoiceId = new URL(document.location).searchParams.get('invoice_id')

    const paymentTypesFunction = (currency) => {
        const type = paymentTypes.filter((item) => {
            if (item.currency) {
                return item.currency.includes(currency)
            }

        })

        return type.map((item) => {
            if (item.payment_type === 'StripePayment') {
                return 'Stripe'
            } else if (item.payment_type === 'CheckoutPayment ') {
                return 'Checkout'
            } else {
                return item.payment_type
            }

        })
    }


    const [selectedService, setSelectedService] = useState(null)
    const [numberCard, setNumberCard] = useState('')
    const [nameUserCard, setNameUserCard] = useState('')
    const [monthCard, setMonthCard] = useState('')
    const [yearCard, setYearCard] = useState('')
    const [cvc, setCvc] = useState('')
    const [enterDataForPayment, setEnterDataForPayment] = useState(false)
    const [stripePromise, setStripePromise] = useState(null)
    useEffect(() => {
        if (!invoiceId) return navigate('/not_found')

        payment(invoiceId)
            .then((response) => {
                    if(response.data?.expiration_date){
                        const eDate = (new Date(response.data?.expiration_date)).getTime();
                        const nDate = (new Date().getTime())
                        console.log(eDate, nDate);
                        if(eDate < nDate) {
                            setIsExpired(true)
                        } else {
                            setExpireTime(eDate)
                            // console.log(eDate-nDate);
                        }
                    }
                // console.log(response.data)
                getData(response.data.site).then((responseSite) => {
                    setDataSite(responseSite.data.data)
                    document.title = responseSite.data?.data?.title || 'Оплата обучения'
                    if(responseSite.data?.data?.color) document.documentElement.style.setProperty('--main-color', responseSite.data?.data?.color)
                })
                setPayments(response.data)
                setCurrencyType(response.data.amount)
                setPaymentTypes(response.data.payment_types)
                setStripePromise(loadStripe(response.data.payment_types.find((item) => item.payment_type === "StripePayment")?.public_key))


            })
            .catch((error) => {console.error(error); setIsExpired(true)})
    }, [])

    useEffect(() => {

        if (selectedCurrency) {
            if (paymentTypesFunction(selectedCurrency?.code.toUpperCase()).includes('Stripe')) {
                setSelectedService(paymentTypesFunction(selectedCurrency?.code.toUpperCase()).find((item) => item === "Stripe"))
            } else {
                setSelectedService(paymentTypesFunction(selectedCurrency?.code.toUpperCase())[0])
            }
        }
    }, [selectedCurrency])

    const typeCurrency = () => {
        const arr = []
        paymentTypes.forEach((item) => {
            if (item.currency) {
                item.currency.forEach((it) => {
                    if (!arr.includes(it)) {
                        arr.push(it)
                    }
                })
            }
        })
        return arr
    }



    useEffect(() => {

        let arr = []
        currency.map((item) => {
            if (typeCurrency().includes(item.code.toUpperCase())) {
                arr.push(item)
            }

        })
        setFilters(arr)
        setSelectedCurrency(arr[0])

    }, [paymentTypes])

    const tinkoff = paymentTypes.find((item) => item.payment_type === 'TinkoffCredit')
    const otp = paymentTypes.find((item) => item.payment_type === 'OTP')

    const payHandler = () => {
        const paymentType = selectedService === 'Checkout' ? 'CheckoutPayment' : selectedService
        window.location.href = `${baseUrl}/api/${invoiceId.length > 11?'payment-invoice':'payment'}/?apply_config=${payments.apply_config_id}&currency=${selectedCurrency?.code.toUpperCase()}&payment_type=${paymentType}&apply_id=${invoiceId}&email=${payments.email}`

    }

    const installmentHandler = () => {
        window.location.href = `${baseUrl}/api/${invoiceId.length > 11?'payment-invoice':'payment'}?apply_config=${payments.apply_config_id}&currency=RUB&payment_type=TinkoffCredit&apply_id=${invoiceId}&email=${payments.email}&duration=${selectedMonthTinkoff}`
    }

    const isCredit = () =>
    (
        (
            paymentTypes.find((item) => item.payment_type === 'TinkoffCredit')
            ||
            paymentTypes.find((item) => item.payment_type === 'OTP')
        )
        && currencyType['rub'] > 2000
    )



    const maskCard = (number) => {
        return number.replace(/\s/g, '').replace(/(.{4})/g, "$1 ")
    }

    const paymentSum = Intl.NumberFormat('ru-RU').format(currencyType[selectedCurrency?.code])
    const currencySymbol = selectedCurrency?.symbol






    return (
        <>
            <div className="container mx-auto py-4 md:py-6 lg:py-8 px-3 sm:px-0">
                <div className="card px-4 md:px-5 lg:px-6" id='card-payment'>
                    {(payments && dataSite && !isExpired) ? (
                        <>
                            {!enterDataForPayment ?
                                <div className="grid justify-content-between px-2">
                                    <div className={selectedCurrency?.code === 'rub' && isCredit() ? 'col-12 md:col-6 flex mb-6' : 'col-12 flex'}>
                                        <div className="flex flex-column justify-content-between w-full lg:pr-6 lg:pl-5">
                                            <div className={selectedCurrency?.code === 'rub' && isCredit() ? 'grid flex-column' : 'grid'}>
                                                <div className={selectedCurrency?.code === 'rub' && isCredit() ? 'col-12' : 'col-12 md:col-6 flex flex-column justify-content-between'}>
                                                    <div className="mb-5">
                                                        <h3 className="title">Оплата курса</h3>
                                                        <p className="course my-5">{dataSite.title}</p>
                                                        <p className="course my-5">{payments.name}</p>
                                                        {expireTime && <p className='mb-5' >
                                                            <Timer style={{fontSize:'18px'}} className={'course my-5'} data={{timer_title:'Оплатите счет в течение: ', timer_date : expireTime, is_timer: true}} />
                                                        </p>}
                                                        <p className="email">{payments.email}</p>

                                                    </div>

                                                    <div className={selectedCurrency?.code === 'rub' && isCredit() ? 'hidden' : 'label up justify-content-center md:justify-content-start w-full hidden md:flex'}>
                                                        <Logo data={dataSite} />
                                                    </div>
                                                </div>

                                                <div className={selectedCurrency?.code === 'rub' && isCredit() ? 'col-12 lg:mt-8' : 'col-12 md:col-6 lg:pl-8'}>
                                                    <h5 className="select-title">Выберите валюту оплаты.</h5>

                                                    <Dropdown className="select w-full" value={selectedCurrency} options={filters} onChange={(e) => setSelectedCurrency(e.value)} optionLabel="name" />
                                                    {(selectedCurrency.code === 'eur' || selectedCurrency.code === 'usd') &&
                                                        <Dropdown className="select w-full my-3" value={selectedService} options={paymentTypesFunction(selectedCurrency.code.toUpperCase())} onChange={(e) => setSelectedService(e.value)} placeholder='сервис оплаты' />}

                                                    {(paymentTypes.filter((item) => item.currency?.includes(selectedCurrency?.code.toUpperCase())).includes(paymentTypes.find((it) => it.payment_type === 'StripePayment')) && selectedService === 'Stripe') &&
                                                        <>
                                                            <Elements stripe={stripePromise}>
                                                                <CheckoutForm invoiceId = {invoiceId} paymentSum={paymentSum} currencySymbol={currencySymbol} payments={payments} selectedCurrency={selectedCurrency} />
                                                            </Elements>
                                                        </>
                                                    }
                                                    <div>
                                                        {selectedService !== 'Stripe' &&
                                                            <>
                                                                <p className="select-title mt-5 mb-0">К оплате</p>
                                                                <p className="sum">
                                                                    {Intl.NumberFormat('ru-RU').format(currencyType[selectedCurrency?.code])} {selectedCurrency?.symbol}

                                                                </p>
                                                                <Button className="btn-pay w-full mt-4" label="Оплатить" onClick={payHandler} />
                                                            </>
                                                        }

                                                        {paymentTypes &&
                                                            <>
                                                                {(selectedCurrency.code === 'eur' || selectedCurrency.code === 'usd') ?
                                                                    <>
                                                                        {selectedService &&
                                                                            <p className="pay-text mt-3">Оплата с помощью {selectedService}</p>}
                                                                    </>

                                                                    :
                                                                    <p className="pay-text mt-3">Оплата с помощью {paymentTypes.find((item) => item.currency?.includes(selectedCurrency?.code.toUpperCase())).payment_type}</p>
                                                                }

                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={selectedCurrency?.code === 'rub' && isCredit() ? 'label up justify-content-center md:justify-content-start w-full hidden md:flex mt-3' : 'hidden'}>
                                                <Logo data={dataSite} />
                                            </div>
                                        </div>

                                        <Divider className={selectedCurrency?.code === 'rub' && isCredit() ? 'hidden md:block' : 'hidden'} layout="vertical" />
                                    </div>

                                    <div className={selectedCurrency?.code === 'rub' && isCredit() ? 'col-12 md:col-6 flex flex-column align-items-center' : 'hidden'}>
                                        <h5 className="title-installment mt-5 mb-6 align-self-start lg:ml-6">Оплата в рассрочку</h5>

                                        <div className="w-full flex flex-column align-items-center justify-content-center">
											{(tinkoff && currencyType['rub'] > 3164) && (
                                                <div className="card-bank relative w-full lg:w-10 mb-6">
                                                    <img className="absolute tinkoff" src="/assets/tinkoff.svg" alt="" />
                                                    <p className="mt-5 sum-payment">
                                                        от {Intl.NumberFormat('ru-RU').format(Math.round(currencyType[selectedCurrency?.code] / selectedMonthTinkoff))} {selectedCurrency?.symbol}/мес
                                                    </p>
                                                    <ButtonsInstallment installment={Object.keys(tinkoff.installment)} selectedMonthTinkoff={selectedMonthTinkoff} setSelectedMonthTinkoff={setSelectedMonthTinkoff} />

                                                    <div className="px-0 lg:px-8">
                                                        <Button className="btn-apply yellow w-full mt-5" label="Оформить" onClick={installmentHandler} />
                                                    </div>
                                                </div>
                                            )}
                                            {otp && (
                                                <div className="card-bank relative mb-6 lg:w-10">
                                                    <img className="absolute otp" src="/assets/otp.svg" alt="" />
                                                    <p className="mt-5 sum-payment">
                                                        от {Intl.NumberFormat('ru-RU').format(Math.round(currencyType[selectedCurrency?.code] / 24))} {selectedCurrency?.symbol}/мес
                                                    </p>
                                                    <p className="otp-text mt-4">Страница для оформления рассрочки от ОТП Банк откроется в новой вкладке.</p>
                                                    <div className="px-0 lg:px-8">
                                                        <a className="no-underline" href={otp.link}>
                                                            <Button className="btn-apply green w-full mt-5" label="Оформить" />
                                                        </a>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div> :
                                <>
                                    {/* <div className="grid">
                                        <div className="col-12 md:col-6">

                                            <div className="mb-5">
                                                <h3 className="title">Оплата участия</h3>
                                                <p className="course my-5">{dataSite.title}</p>
                                                <p className="course my-5">{payments.name}</p>
                                                <p className="email">{payments.email}</p>
                                            </div>


                                            <div className={selectedCurrency?.code === 'rub' && isCredit() ? 'hidden' : 'label up justify-content-center md:justify-content-start w-full hidden md:flex'}>
                                                <Logo data={dataSite} />
                                            </div>
                                        </div>

                                        <div className='col-12 md:col-6 lg:pl-8 lg:pr-6'>
                                            <h5 className="select-title my-3">Введите данные для оплаты</h5>

                                            <Dropdown className="select w-full mb-3" value={selectedService} options={service} onChange={(e) => setSelectedService(e.value)} optionLabel="name" placeholder='сервис оплаты' />
                                            <InputText className='w-full mb-3' value={numberCard} onChange={(e) => setNumberCard(maskCard(e.target.value))} placeholder='номер карты'></InputText>
                                            <InputText className='w-full mb-3' value={nameUserCard} onChange={(e) => setNameUserCard(e.target.value)} placeholder='имя как на карте'></InputText>
                                            <div className="flex justify-content-between ">
                                                <InputText className='w-4' value={dateCard} onChange={(e) => setDateCard(e.target.value)} placeholder='дата'></InputText>
                                                <InputText className='w-4' value={cvc} onChange={(e) => setCvc(e.target.value)} placeholder='cvc/cvv'></InputText>
                                            </div>

                                            <div>
                                                <p className="select-title mt-5 mb-0">К оплате</p>
                                                <p className="sum">
                                                    {Intl.NumberFormat('ru-RU').format(currencyType[selectedCurrency?.code])} {selectedCurrency?.symbol}
                                                </p>
                                                <Button className="btn-pay w-full mt-4" label="Оплатить" onClick={payHandler} />

                                            </div>
                                        </div>
                                    </div>
 */}
                                </>
                            }
                        </>
                    ) : (
                        <>
                            {isExpired && <h2>Счет не найден или время его оплаты истекло</h2>} 
                            {!isExpired && <Skeletons />}
                        </>
                    )}
                </div>
                <Footer data={data} dataSite={dataSite} />
            </div>
        </>
    )
}
